{
  "includedProducts": {
    "seatWifi": {
      "text": "Suosittu paikka {seatNumber} + Koko lennon Stream-paketti",
      "title": "Istuinpaikka + Wifi"
    },
    "bundle": {
      "title": "Combot"
    }
  },
  "services": {
    "bundle": {
      "amount": {
        "seatWifi": "{amount} x Istuinpaikka + Internet-yhteys"
      },
      "summary-title": "Combot",
      "seatWifi": "Istuinpaikka + Internet-yhteys"
    }
  },
  "notifications": {
    "tripContainsTrain": {
      "link": {
        "url": "#"
      }
    }
  }
}
